import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "mantine-datatable/styles.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MantineProvider } from "@mantine/core";
import { BrowserRouter } from "react-router-dom";
import { StoreContext, rootStore } from "./stores/rootStore";
import { DEV_MODE, DEV_TOKEN } from "./devMode";
import { Notifications } from "@mantine/notifications";
import theme from "./assets/styles/theme";
import { GoogleOAuthProvider } from "@react-oauth/google";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MantineProvider theme={theme} withGlobalClasses>
        <StoreContext.Provider value={rootStore}>
          <GoogleOAuthProvider clientId="220976322179-1trvvtf7nmqdbl1uhtfa55lu2187l9fi.apps.googleusercontent.com">
            <Notifications />
            <App />
          </GoogleOAuthProvider>
        </StoreContext.Provider>
      </MantineProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

console.log("Dev mode settings:", "dev mode", DEV_MODE, "dev token", DEV_TOKEN);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
